import i18n from "i18n";

export type UserApp = {
  id: number;
  tz: string;
  fullName: string;
  phoneNumber: string;
  email: string;
  downloadTime: string | null;
  isVerifyByMimshalZamin: boolean;
  address?: string;
  operationSystem?: string[];
  dateOfBirth: string | null;
  currentVersion?: string[];
  disable: boolean;
  lastReportUpdate: string | null;
  isEntitledCamera?: boolean;
  cameraUuid?: string | null;
  cameraUuidStartDate?: string | null;
  usersCharacteristic?: string | null;
};

export type ValidationUserApp = {
  tz: string;
  phoneNumber: string;
  email: string;
};

export type VolunteerReportsDecisionsCount = {
  notificationLetterSent: number;
  seriousNotificationLetterSent: number;
  reportsSentToPolice: number;
  reportsRejected: number;
};

export type volunteersDataTable = {
  volunteersData: volunteerData[];
  pageCount: number;
  totalVolunteersCount: number;
};

export type volunteerData = {
  userApp: UserApp;
  volunteerReportsDecisionsCount: VolunteerReportsDecisionsCount;
};

export const verifyStatuses = [
  {
    label: i18n.t("notVerified"),
    value: 0,
  },
  {
    label: i18n.t("verified"),
    value: 1,
  },
];
export type VolunteersListQueryBody = {
  fullName?: string;
  tz?: number;
  registrationDate?: string;
  isVerify?: boolean;
  operationSystem?;
  currentVersion?: string;
  lastReportUpdate?: string;
  characteristic?: string;
};
